<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P0003606.installation.protection' | translate"
      [description]="'P0003606.installation.protection.description' | translate"
    >
    </app-header-configuration>

    <app-switch-configuration
      [title]="'P0003606.installation.protectionSurdosage' | translate"
      [nameCustom]="
        'P0003606.installation.protectionSurdosage.value' | translate
      "
      [value]="actionStack!.getValue('icIActivationProtectionSurdosage') !== 0"
      [information]="EnSavoirPlusPage"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.InjectionPh_Installation,
          'iphIActivationProtectionSurdosage',
          $event ? 1 : 0,
          null
        )
      "
    >
    </app-switch-configuration>

    <app-label-configuration
      [titleListe]="'P0003606.parametrage.limiteSurdosage.value' | translate"
      [value]="actionStack!.getValue('iphPDureeLimiteSurdosage')"
      [liste]="P0003606DureeLimiteSurdosage"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.InjectionPh_Parametrage,
          'iphPDureeLimiteSurdosage',
          $event,
          null
        )
      "
    >
    </app-label-configuration>

    <app-label-description
      [description]="
        'P0003606.installation.protectionSurdosage.description' | translate
      "
    ></app-label-description>

    @if (isSupportTechnique()) {
      <app-switch-configuration
        [title]="'P0003606.parametrage.securitePh' | translate"
        [nameCustom]="'P0003606.parametrage.securitePh.value' | translate"
        [description]="
          'P0003606.parametrage.securitePh.description' | translate
        "
        [value]="actionStack!.getValue('iphIActivationSecuritePh') !== 0"
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.InjectionPh_Installation,
            'iphIActivationSecuritePh',
            $event ? 1 : 0,
            null
          )
        "
      >
      </app-switch-configuration>
    }

    @if (showPositionModal()) {
      <app-information-title
        [title]="'P0003606.parametre.sourcereference' | translate"
      ></app-information-title>

      <div class="my-3">
        <app-affichage-warning
          icon="fa-regular fa-exclamation-circle"
          [name]="'configuration.presentationmiseenservice.warning' | translate"
        ></app-affichage-warning>
      </div>

      <app-larged-link
        [name]="'P0003606.configuration.sourceDebut' | translate"
        (onPress)="openPositionModal()"
      ></app-larged-link>

      <app-label-description
        [description]="
          'P0003606.parametre.sourcereference.description' | translate
        "
      ></app-label-description>
    }
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
